import React, { Component } from "react";
import NavbarPage from "../../components/Navbar/NavbarPage";
import Section from "./section";
import Services from "../../components/Services/services";
import WebsiteDescription from "../../components/Website Description/website-description";
import Pricing from "../../components/Pricing/pricing";
import ContactUs from "../../components/Contact Us/contact-us";
import Footer from "../../components/Footer/footer";
import FreeTools from "../../components/Tools/freetools";
import "./LandingPage.css";

class Index3 extends Component {
  componentDidMount() {
    const theme = document.getElementById("colorTheme");
    if (theme) {
      theme.href = "assets/colors/green.css";
    }
  }

  render() {
    return (
      <div className="pwlp-page">
        <NavbarPage />
        <Section />
        <Services />
        <FreeTools />
        <WebsiteDescription />
        <Pricing />
        <ContactUs />
        <Footer />
      </div>
    );
  }
}

export default Index3;


// import React, { Component } from 'react';
// import NavbarPage from "../../components/Navbar/NavbarPage";
// import Section from "./section";
// import Features from '../../components/Features/features';
// import Services from '../../components/Services/services';
// import WebsiteDescription from '../../components/Website Description/website-description';
// //import AboutUs from '../../components/About Us/about-us';
// import Pricing from '../../components/Pricing/pricing';
// //import Testimonials from '../../components/Testimonials/testimonials';
// import GetStarted from '../../components/Get Started/get-started';
// //import Blog from '../../components/Blog/blog';
// import ContactUs from '../../components/Contact Us/contact-us';
// import Footer from '../../components/Footer/footer';

// class Index3 extends Component {
//     constructor(props) {
//         super(props);
//         this.state = {
//           navClass : "navbar-white"
//         };
//     }
//         componentDidMount()
//     {
//         document.getElementById("colorTheme").href="assets/colors/green.css";
//     }

//     render() {
//         return (
//             <React.Fragment>

//                 {/* Importing Navbar */}
//                 <NavbarPage navClass={this.state.navClass}/>

//                 {/* Importing Section */}
//                 <Section/>
            

//                 {/* Importing Features */}
//                 <Features/>

//                 {/* Importing Website Description */}
//                 <WebsiteDescription/>

//                 {/* Importing Services */}
//                 <Services/>

                

//                 {/* Importing About Us */}
               
//                 <div id="about"></div> {/* Prevents scrollSpy.js from failing */}


//                 {/* Importing Pricing */}
//                 <Pricing/>

//                 {/* Importing Testimonials */}
//                 {/* <Testimonials/> */}

//                 {/* Importing Get Started */}
//                 <GetStarted/>

//                 {/* Importing Blog */}
                
//                 {/* <div id="blog"></div> */}


//                 {/* Importing Contact Us */}
//                 <ContactUs/>

//                 {/* Importing Get Footer */}
//                 <Footer/>

//             </React.Fragment>
//         );
//     }
// }

// export default Index3;